<template>
    <div>
        <open-banking-requests-filter :action="filterAction" ></open-banking-requests-filter>
        <div v-if="$can('manage', 'open-banking')">
            درخواست های من
            <label class="switch m-0 mr-2 ml-2">
                <input id="application_checkbox" type="checkbox" @change="checkbox_changed">
                <span class="slider round"></span>
            </label>
            تمام درخواست ها
        </div>
        <kt-datatable v-bind="datatableProps" ref="statementsDatatable"></kt-datatable>
    </div>
</template>

<script>
import requestsColumns from './datatable/requests-columns'
import {ApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import $ from "jquery";
import openBankingRequestsFilter from "../statements-filter";

export default {
    name: 'admin-open-banking-statements',

    components: {
        'open-banking-requests-filter': openBankingRequestsFilter,
    },
    data() {
        return {
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "statementsDatatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('open-banking/requests/common/statements'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data
                            },
                            params: this.query || {},
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: requestsColumns,
            }
        },
    },
    methods: {
        filterAction(e, query) {
            this.query = query
            if (this.$refs.statementsDatatable.KTDatatable) {
                this.$refs.statementsDatatable.reload()
            }
        },
        checkbox_changed(e) {
            let checkbox = $('#application_checkbox')

            if (checkbox.is(":checked"))
                this.query.my_requests = 1
            else
                this.query.my_requests = 0

            if (this.$refs.statementsDatatable.KTDatatable) {
                this.$refs.statementsDatatable.reload()
            }
        }
    }
}
</script>

<style>

</style>